var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 517,
    height: 390,
    viewBox: "0 0 517 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M-20.0859 278.979L43.6854 235.942L41.3336 231.43L-23.7869 208.131L-20.0859 278.979Z",
    fill: "#C7F155"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.102 241.854L63.2527 314.411L136.562 564.424L149.72 347.416L132.102 241.854Z",
    fill: "#5ABDC7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.372 342.13C24.5852 343.112 23.1615 343.274 22.1911 342.489C21.2211 341.705 21.074 340.274 21.861 339.293C22.6488 338.31 24.0728 338.15 25.0428 338.934C26.0126 339.717 26.1597 341.148 25.372 342.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7637 169.599C75.9754 170.58 74.5516 170.741 73.5819 169.958C72.6118 169.174 72.4645 167.743 73.2522 166.76C74.0392 165.779 75.463 165.618 76.433 166.401C77.403 167.185 77.5514 168.617 76.7637 169.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.599 356.246C199.811 357.228 198.387 357.389 197.417 356.606C196.448 355.822 196.3 354.391 197.089 353.408C197.875 352.427 199.301 352.266 200.27 353.05C201.238 353.833 201.387 355.263 200.599 356.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.935 277.841C168.147 278.823 166.724 278.984 165.754 278.2C164.784 277.416 164.637 275.985 165.424 275.003C166.211 274.022 167.636 273.861 168.605 274.644C169.575 275.427 169.722 276.859 168.935 277.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.168 406.156L228.121 495.184",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.986 495.511L198.984 354.827",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.945 354.827L117.065 405.83",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.842 354.789L167.174 276.46",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.516 276.422L116.823 405.83",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.166 405.719L40.9133 233.001",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9184 233.26L167.178 276.051",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.969 276.422L147.18 136.354",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.211 136.354L40.6789 232.89",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9199 232.855L5.78545 139.337",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77923 139.614L146.975 136.044",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21875 139.303L-56.9481 304.56",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.6594 304.56L44.5469 235.208",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1797 232.889L23.3516 340.711",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6133 340.991L117.165 405.551",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.816 398.143L232.338 259.412",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.227 256.197L198.583 354.827",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.843 355.266L350.818 398.022",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.338 259.414L344.045 288.148",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.629 398.46L391.953 327.304",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.176 276.176L75.005 168.427",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0054 167.975L5.7824 139.509",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.266 400.743L149.579 348.019",
    stroke: "url(#paint0_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.577 347.951L253.042 340.541",
    stroke: "url(#paint1_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.188 340.741L241.118 401.011",
    stroke: "url(#paint2_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.268 401.242L350.91 398.074",
    stroke: "url(#paint3_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.073 484.321L414.156 384.449",
    stroke: "url(#paint4_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.91 384.392L350.906 398.362",
    stroke: "url(#paint5_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.129 387.825L417.07 348.009",
    stroke: "url(#paint6_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.223 387.955L467.67 389.137",
    stroke: "url(#paint7_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.221 387.622L340.497 336.034",
    stroke: "url(#paint8_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.57 335.831L350.824 398.306",
    stroke: "url(#paint9_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.903 398.02L253.039 341.025",
    stroke: "url(#paint10_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.043 340.914L340.495 335.657",
    stroke: "url(#paint11_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.998 340.741L232.352 258.917",
    stroke: "url(#paint12_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.312 259.229L340.494 335.519",
    stroke: "url(#paint13_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.42 335.831L348.148 305.06",
    stroke: "url(#paint14_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.891 258.917L26.8038 490.719",
    stroke: "url(#paint15_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.313 258.796L177.224 171.697",
    stroke: "url(#paint16_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.317 258.653L131.964 242.455",
    stroke: "url(#paint17_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.094 242.191L149.443 347.753",
    stroke: "url(#paint18_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.357 347.752L232.531 258.917",
    stroke: "url(#paint19_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.962 242.185L102.911 148.035",
    stroke: "url(#paint20_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.912 148.238L177.227 171.366",
    stroke: "url(#paint21_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.414 171.575L133.047 245.653",
    stroke: "url(#paint22_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.909 147.938L61.7047 83.2137",
    stroke: "url(#paint23_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.125 148.028L40.5256 232.937",
    stroke: "url(#paint24_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7399 233.166L131.957 241.964",
    stroke: "url(#paint25_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.141 242.191L62.9346 314.748",
    stroke: "url(#paint26_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1093 314.996L149.576 347.504",
    stroke: "url(#paint27_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.047 347.753L136.649 563.877",
    stroke: "url(#paint28_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.126 563.872L100.12 439.313L63.1134 314.753",
    stroke: "url(#paint29_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1137 314.503L-21.6633 275.018",
    stroke: "url(#paint30_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0894 314.748L40.7656 232.938",
    stroke: "url(#paint31_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7466 232.799L-9.25232 186.816",
    stroke: "url(#paint32_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.37703 186.677L5.88281 139.482",
    stroke: "url(#paint33_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76658 139.721L102.91 147.788",
    stroke: "url(#paint34_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63024 139.482L61.8438 83.1221",
    stroke: "url(#paint35_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78906 139.482L-76.7304 169.144",
    stroke: "url(#paint36_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.04688 186.676L-21.8709 274.772",
    stroke: "url(#paint37_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4505 317.446C64.9535 319.314 62.245 319.619 60.4005 318.128C58.5579 316.639 58.2771 313.916 59.7754 312.049C61.2724 310.182 63.9809 309.876 65.8239 311.366C67.6668 312.856 67.9475 315.579 66.4505 317.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0833 235.636C42.5857 237.502 39.8765 237.809 38.0333 236.318C36.1916 234.829 35.9099 232.106 37.4063 230.24C38.904 228.371 41.6134 228.065 43.4566 229.556C45.2996 231.046 45.5813 233.768 44.0833 235.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10622 142.18C7.60919 144.047 4.90073 144.353 3.05778 142.863C1.21387 141.373 0.933412 138.652 2.4314 136.784C3.92844 134.916 6.6369 134.611 8.47985 136.101C10.3231 137.591 10.6045 140.313 9.10622 142.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.247 150.726C104.75 152.593 102.042 152.899 100.198 151.409C98.355 149.92 98.0743 147.197 99.5716 145.331C101.07 143.463 103.778 143.157 105.62 144.647C107.464 146.137 107.744 148.859 106.247 150.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.301 244.889C133.805 246.757 131.095 247.062 129.252 245.571C127.409 244.082 127.127 241.359 128.625 239.492C130.123 237.625 132.832 237.318 134.674 238.809C136.519 240.3 136.8 243.021 135.301 244.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.567 174.273C179.07 176.14 176.362 176.446 174.517 174.955C172.675 173.465 172.394 170.743 173.891 168.875C175.39 167.008 178.097 166.702 179.941 168.193C181.784 169.683 182.065 172.405 180.567 174.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0433 85.8201C63.5459 87.6867 60.8375 87.9923 58.9933 86.5018C57.1506 85.0128 56.8699 82.2902 58.3675 80.4246C59.8652 78.5558 62.5737 78.2502 64.4166 79.7401C66.2608 81.2307 66.5419 83.9511 65.0433 85.8201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.653 261.616C234.155 263.482 231.448 263.789 229.603 262.298C227.76 260.808 227.48 258.087 228.977 256.219C230.475 254.352 233.183 254.046 235.027 255.537C236.871 257.026 237.15 259.748 235.653 261.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.834 338.529C342.336 340.396 339.628 340.702 337.785 339.212C335.941 337.721 335.661 335.001 337.158 333.133C338.656 331.266 341.364 330.96 343.207 332.45C345.049 333.941 345.33 336.661 343.834 338.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.379 343.438C254.882 345.306 252.175 345.611 250.33 344.121C248.487 342.631 248.206 339.909 249.703 338.043C251.203 336.176 253.91 335.868 255.754 337.36C257.597 338.849 257.877 341.572 256.379 343.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.918 350.451C151.421 352.318 148.713 352.624 146.87 351.134C145.026 349.643 144.745 346.923 146.242 345.055C147.741 343.188 150.449 342.882 152.292 344.373C154.136 345.862 154.416 348.584 152.918 350.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.559 390.524C413.062 392.392 410.353 392.697 408.51 391.207C406.666 389.717 406.387 386.996 407.884 385.128C409.381 383.262 412.089 382.955 413.933 384.446C415.776 385.936 416.057 388.656 414.559 390.524Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.4505 317.446C64.9535 319.314 62.245 319.619 60.4005 318.128C58.5579 316.639 58.2771 313.916 59.7754 312.049C61.2724 310.182 63.9809 309.876 65.8239 311.366C67.6668 312.856 67.9475 315.579 66.4505 317.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0833 235.636C42.5857 237.502 39.8765 237.809 38.0333 236.318C36.1916 234.829 35.9099 232.106 37.4063 230.24C38.904 228.371 41.6134 228.065 43.4566 229.556C45.2996 231.046 45.5813 233.768 44.0833 235.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10622 142.18C7.60919 144.047 4.90073 144.353 3.05778 142.863C1.21387 141.373 0.933412 138.652 2.4314 136.784C3.92844 134.916 6.6369 134.611 8.47985 136.101C10.3231 137.591 10.6045 140.313 9.10622 142.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.247 150.726C104.75 152.593 102.042 152.899 100.198 151.409C98.355 149.92 98.0743 147.197 99.5716 145.331C101.07 143.463 103.778 143.157 105.62 144.647C107.464 146.137 107.744 148.859 106.247 150.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.301 244.889C133.805 246.757 131.095 247.062 129.252 245.571C127.409 244.082 127.127 241.359 128.625 239.492C130.123 237.625 132.832 237.318 134.674 238.809C136.519 240.3 136.8 243.021 135.301 244.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.567 174.273C179.07 176.14 176.362 176.446 174.517 174.955C172.675 173.465 172.394 170.743 173.891 168.875C175.39 167.008 178.097 166.702 179.941 168.193C181.784 169.683 182.065 172.405 180.567 174.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0433 85.8201C63.5459 87.6867 60.8375 87.9923 58.9933 86.5018C57.1506 85.0128 56.8699 82.2902 58.3675 80.4246C59.8652 78.5558 62.5737 78.2502 64.4166 79.7401C66.2608 81.2307 66.5419 83.9511 65.0433 85.8201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.653 261.616C234.155 263.482 231.448 263.789 229.603 262.298C227.76 260.808 227.48 258.087 228.977 256.219C230.475 254.352 233.183 254.046 235.027 255.537C236.871 257.026 237.15 259.748 235.653 261.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.834 338.529C342.336 340.396 339.628 340.702 337.785 339.212C335.941 337.721 335.661 335.001 337.158 333.133C338.656 331.266 341.364 330.96 343.207 332.45C345.049 333.941 345.33 336.661 343.834 338.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.379 343.438C254.882 345.306 252.175 345.611 250.33 344.121C248.487 342.631 248.206 339.909 249.703 338.043C251.203 336.176 253.91 335.868 255.754 337.36C257.597 338.849 257.877 341.572 256.379 343.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.918 350.451C151.421 352.318 148.713 352.624 146.87 351.134C145.026 349.643 144.745 346.923 146.242 345.055C147.741 343.188 150.449 342.882 152.292 344.373C154.136 345.862 154.416 348.584 152.918 350.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.559 390.524C413.062 392.392 410.353 392.697 408.51 391.207C406.666 389.717 406.387 386.996 407.884 385.128C409.381 383.262 412.089 382.955 413.933 384.446C415.776 385.936 416.057 388.656 414.559 390.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.5325 217.96L-20.1484 120.219",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.7031 -0.677734L27.0922 490.718",
    stroke: "url(#paint38_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.9922 -0.677734L-158.094 414.784",
    stroke: "url(#paint39_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.166 23.5883L27.3827 490.425",
    stroke: "url(#paint40_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6516 419.315L-23.8946 208.305",
    stroke: "url(#paint41_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.8934 208.694L130.452 264.217",
    stroke: "url(#paint42_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.1453 208.264L52.0078 106.182",
    stroke: "url(#paint43_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.751 106.313L130.451 264.516",
    stroke: "url(#paint44_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.143 264.648L154.93 134.155",
    stroke: "url(#paint45_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.625 133.988L84.2139 38.9283",
    stroke: "url(#paint46_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3828 38.7617L51.5802 106.182",
    stroke: "url(#paint47_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7504 106.449L153.164 127.458",
    stroke: "url(#paint48_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3206 43.5421L53.7982 10.1004",
    stroke: "url(#paint49_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1954 43.6242L126.922 -6.91309",
    stroke: "url(#paint50_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3198 43.6068L-11.548 71.2284",
    stroke: "url(#paint51_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.5509 71.3904L51.7495 106.002",
    stroke: "url(#paint52_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7969 106.182L-69.4729 154.593",
    stroke: "url(#paint53_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.6341 154.592L-11.3438 71.21",
    stroke: "url(#paint54_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-136.818 254.605L47.6509 418.852",
    stroke: "url(#paint55_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6538 418.581L-227.904 310.359",
    stroke: "url(#paint56_radial_15773_19574)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5772 105.047C57.1776 107.725 55.5042 110.403 52.8381 111.028C50.1707 111.655 47.5241 109.994 46.924 107.317C46.3237 104.64 47.9964 101.963 50.6622 101.337C53.3291 100.707 55.9772 102.37 56.5772 105.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.281 263.514C135.881 266.19 134.207 268.868 131.542 269.494C128.875 270.122 126.228 268.46 125.627 265.783C125.027 263.106 126.699 260.428 129.366 259.802C132.033 259.175 134.68 260.836 135.281 263.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1484 42.4921C90.75 45.1672 89.0764 47.8445 86.4102 48.4726C83.7444 49.0986 81.0965 47.4363 80.4949 44.7613C79.8945 42.0837 81.5679 39.4055 84.2344 38.7783C86.9002 38.1523 89.5483 39.8156 90.1484 42.4921Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(29.1349 23.5491 -23.6592 29.5073 195.423 374.382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(28.5862 23.0419 -23.2177 28.8666 201.31 344.247)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(16.8673 13.6277 -13.6977 17.0751 247.153 370.876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(30.2304 24.3791 -24.5523 30.5428 296.089 399.658)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(28.2924 22.8631 -22.9755 28.6473 400.615 434.385)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(17.8107 14.3188 -14.4686 17.9349 382.408 391.377)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(11.0991 8.96551 -9.01354 11.2334 414.099 367.917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(15.6293 12.6101 -12.6933 15.7988 439.446 388.546)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(24.0887 19.4695 -19.5615 24.3955 375.858 361.829)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(17.5084 14.0943 -14.2218 17.6553 345.697 367.068)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.1923 25.212 -25.33 31.5911 301.971 369.523)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(24.1671 19.4826 -19.6283 24.4078 296.769 338.286)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(23.3609 18.7588 -18.9786 23.4944 242.675 299.829)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(36.4246 29.4405 -29.579 36.8892 286.403 297.374)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.74933 7.07001 -7.10512 8.85861 344.284 320.445)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(84.5294 68.293 -68.6444 85.57 129.848 374.818)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(28.3941 22.9119 -23.0605 28.7054 204.769 215.246)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(28.0498 22.6522 -22.7792 28.3821 182.14 250.554)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(29.4911 23.7403 -23.9551 29.7383 140.768 294.972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(33.1867 26.8097 -26.9503 33.5919 190.945 303.335)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(27.2826 21.8873 -22.1658 27.411 117.436 195.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.495 17.3682 -17.4555 21.7623 140.07 159.802)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(23.547 19.0317 -19.1216 23.847 155.231 208.614)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.1597 17.0748 -17.185 21.3923 82.3069 115.576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(28.7419 23.2269 -23.3403 29.1034 71.8254 190.483)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(25.2949 20.42 -20.5425 25.5846 86.3481 237.565)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(27.3517 22.0952 -22.2119 27.6847 97.5371 278.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(25.4877 20.5973 -20.6977 25.8084 106.343 331.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(59.2537 47.8394 -48.1215 59.9382 143.348 455.815)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(71.7823 57.5578 -58.3214 72.0814 100.12 439.313)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(25.7881 20.8426 -20.9415 26.116 20.725 294.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(23.4939 18.8507 -19.0875 23.6082 51.9273 273.843)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(18.6925 15.1051 -15.1797 18.9266 15.7473 209.808)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(13.6006 10.9918 -11.0446 13.7727 -1.74719 163.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(26.8974 21.7117 -21.844 27.2029 54.3384 143.755)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.7285 17.551 -17.6455 21.9909 33.7368 111.302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(24.1209 19.3822 -19.5953 24.2761 -35.471 154.313)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(24.4004 19.7096 -19.8155 24.6952 -15.4588 230.724)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(175.068 -40.8528 39.3961 174.547 -33.305 245.021)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(144.248 -33.8995 32.4889 144.712 -125.543 207.053)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(176.321 -41.2707 39.6924 176.268 -75.3915 257.007)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(77.1264 -17.9941 17.3678 76.9314 11.8787 313.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(56.8424 -13.359 12.8118 57.0618 53.2795 236.455)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(43.7592 -10.2843 9.86299 43.9287 13.9312 157.223)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(61.0864 -14.3088 13.7623 61.1459 91.1011 185.415)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(45.627 -10.7197 10.2833 45.7913 142.537 199.401)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(40.9629 -9.61678 9.23124 41.0838 119.42 86.4585)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(25.8186 -6.06932 5.81943 25.9241 67.9814 72.4721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(35.9026 -8.4333 8.09167 36.0244 102.457 116.954)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(16.0207 -3.76391 3.6107 16.0783 69.5594 26.8214)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(22.602 -5.31117 5.09423 22.6866 106.059 18.3556)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.6898 -8.08472 7.81032 34.5712 36.8859 57.4177)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(25.1057 -5.90168 5.65875 25.208 20.0992 88.6961)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.9564 -10.5052 10.1254 44.9052 -8.83808 130.387)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.9867 -8.22322 7.8858 35.1245 -40.4888 112.901)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(85.4858 -20.0906 19.2675 85.817 -44.5837 336.729)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_15773_19574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(102.477 -24.0856 23.0977 102.879 -90.1251 364.471)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11);
export default __webpack_public_path__ + "static/media/Group 11.ee5a90f0f6d486f5728ff8a4703c67fa.svg";
export { ForwardRef as ReactComponent };